<div class="container">
  <div class="modalHeader">
    <div class="d-flex justify-content-end mt-1">
      <app-dialog-button></app-dialog-button>
    </div>

    <div class="title-modal-mat">Recortar foto do perfil</div>
    <p class="perfil-crop-sub">
      Arraste a foto e use o zoom para escolher o que aparece dentro do círculo.
    </p>
  </div>

  <div mat-dialog-content>
    <div class="perfil-crop-area">
      <image-cropper
        [imageFile]="arquivo"
        [maintainAspectRatio]="false"
        [cropperStaticWidth]="janelaRecorte"
        [cropperStaticHeight]="janelaRecorte"
        [roundCropper]="true"
        [allowMoveImage]="true"
        [hideResizeSquares]="true"
        [transform]="transform"
        [resizeToWidth]="tamanhoFoto"
        [containWithinAspectRatio]="false"
        alignImage="center"
        output="base64"
        format="png"
        cropperFrameAriaLabel="Área circular da foto do perfil"
        (cropperReady)="aoPrepararRecorte($event)"
        (loadImageFailed)="aoFalharCarregamento()"
        (transformChange)="aoMoverFoto($event)"
        (imageCropped)="onImageCropped($event)">
      </image-cropper>
    </div>

    <div class="perfil-crop-controles">
      <div class="perfil-crop-zoom">
        <button type="button" class="perfil-crop-zoom-btn" title="Diminuir zoom" (click)="diminuirZoom()"
          aria-label="Diminuir zoom">
          <i-lucide name="minus" size="18"></i-lucide>
        </button>

        <input
          type="range"
          class="perfil-crop-slider"
          [min]="zoomMin"
          [max]="zoomMax"
          [step]="zoomPasso"
          [value]="zoom"
          aria-label="Zoom da foto"
          (input)="onZoomChange($any($event.target).valueAsNumber)">

        <button type="button" class="perfil-crop-zoom-btn" title="Aumentar zoom" (click)="aumentarZoom()"
          aria-label="Aumentar zoom">
          <i-lucide name="plus" size="18"></i-lucide>
        </button>

        <button type="button" class="perfil-crop-zoom-btn" title="Voltar ao enquadramento inicial"
          (click)="reposicionar()" aria-label="Voltar ao enquadramento inicial">
          <i-lucide name="rotate-ccw" size="16"></i-lucide>
        </button>
      </div>

      <div class="perfil-crop-previa">
        <span class="perfil-crop-previa-caixa">
          <img *ngIf="previa" [src]="previa" alt="Prévia da foto do perfil" />
        </span>
        <small>Prévia</small>
      </div>
    </div>

    <div class="d-flex justify-content-end mb-3 gap-2">
      <button type="button" class="btn btn-cancelar-modal" mat-dialog-close>
        Voltar
      </button>
      <button type="button" class="btn btn-import" [disabled]="!podeConfirmar" (click)="confirmar()">
        Confirmar Recorte
      </button>
    </div>
  </div>
</div>
